/**
 * Shows a queue of quick temporary notifications, most recent at the top.
 * Each notification is visible for QUICK_MESSAGE_DURATION and takes QUICK_MESSAGE_FADE_OUT_DURATION to fade out.
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import QuickMessage from './QuickMessage';

const styles = theme => ({
	quickMessages: {
		position: 'absolute',
		top: '100px',
		right: '28px'
	}
});

@withStyles(styles)
class QuickMessages extends Component {

	render() {
		const { classes, quickMessages } = this.props;
		const messages = Object.entries(quickMessages)
			// most recent message displayed at the top
			.sort((a, b) => b[1].created - a[1].created)
			.map((entry) => {
				let key = entry[0];
				let quickMessage = entry[1];
				return <QuickMessage key={key} {...quickMessage} />;
			});
		return <div className={classes.quickMessages}>{messages}</div>;
	}

}

QuickMessages.propTypes = {
	classes: PropTypes.object,
	quickMessages: PropTypes.object
};

const mapStateToProps = state => ({
	quickMessages: state.quickMessages
});

export default connect(
	mapStateToProps
)(QuickMessages);


// WEBPACK FOOTER //
// ./src/components/QuickMessages/QuickMessages.js